import { useMutation } from '@tanstack/react-query';
import { addContactAddress } from '../../services/fn-api/User';

export const useAddContactAddress = () => {
  return useMutation<Record<string, unknown>, Error, Record<string, unknown>>({
    mutationFn: async (contactAddress) => {
      const { createdDate, ...data } = contactAddress;
      return addContactAddress(data);
    },
  });
};
